import React, { Component } from 'react';
import { get, isEmpty } from 'Utils/lodashUtils';
import PropTypes from 'prop-types';
import GDAccountNumberCell from 'Components/GDTable/GDAccountNumberCell/GDAccountNumberCell';
import GDColorCodedCell from 'Components/GDTable/GDColorCodedCell/GDColorCodedCell';
import GDDateCell from 'Components/GDTable/GDDateCell';
import GDCurrencyCodeCell from 'Components/GDTable/GDCurrencyCodeCell';
import CardType from 'Components/CardType';
import AccountIcon from 'Assets/img/accounting-data.svg';
import MerchantIcon from 'Assets/img/merchant-overview.svg';
import BankIcon from 'Assets/img/banking-information.svg';
import SchemeIcon from 'Assets/img/scheme-data.svg';
import TransactionIcon from 'Assets/img/transaction-overview.svg';
import DisputeIcon from 'Assets/img/dispute-overview.svg';
import { Row, Col } from 'antd';
import InformationBubble from 'Components/information-bubble/InformationBubble';
import OpenNewWindowIcon from 'Components/icons/OpenNewWindowIcon';
import { numberWithCommas } from 'Utils/formatting.js';
import { customFormatclass, customClassCurrency } from '../GDTable/GDCustomFormat/GDCustomFormat';
import StatusChip from '../ExpandedOverviewPane/components/StatusChip/StatusChip';
import {dateFormatter} from "Utils/dateUtils";
//import 'antd/dist/antd.css';
import './OverviewPane.scss';
import SearchIcon from 'Components/icons/SearchIcon';
import { VITE_CITI_BRANDED_URL } from 'Constants/appEnvConstants';
import { COLORS } from "Constants/BIDashboardConstants"

class OverviewPane extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.findHeight(this.props.id, false);
  }

  setTxnLeftRowValue = (keyValueArr) => {
    const originCode = keyValueArr.map(
      (element, index) => {
          return (
              <React.Fragment key={index}>
                <span className={(get(this.props.data, element.value) !== 'F' ? (element.key === 'Case Stage' ? 'txn-container-left__keyElem__caseStage' : 'txn-container-left__keyElem') : 'txn-container-left__keyElem--foreign_card') }>{element.key}</span>
                <span className='txn-container-left__valueElem'>{get(this.props.data, element.value) === 'F' ? 'F - Foreign' : (get(this.props.data, element.value) === 'D' ? 'D - Domestic' : (get(this.props.data, element.value) ? get(this.props.data, element.value) : '--'))}</span>
                <span className='txn-container-left__tooltip'>
                 { element.description &&
                 <InformationBubble
                    id={`${element.index}`}
                    info
                    tooltipContent={!isEmpty(get(this.props.data, element.description)) ? get(this.props.data, element.description) : "No Description Present"}
                  />}
                </span>
              </React.Fragment>
          )
      }
    )
    return (
      <div className='txn-container-left'>
          {originCode}
      </div>
    )
  }

  getItemData = (item, index) => {
    const key = `${index} ${item.columnKey}`;
    if (!isEmpty(get(this.props.data, item.columnKey))) {
      if (item.displayType === 'DATE') {
        return (
          <span className="date">
            <GDDateCell
              key={key}
              date={get(this.props.data, item.columnKey)}
              dateFormat={this.props.preferences.dateFormat}
              timeFormat={this.props.preferences.timeFormat}
            />
          </span>
        );
      }
      if (item.displayType === 'MERCHANTNUMBER') {
        return (
          <div className="gd-color-coded-cell">
            <GDColorCodedCell
              key={key}
              content={get(this.props.data, item.columnKey)}
            />
          </div>
        );
      }
       if (item.displayType === 'HIERARCHY') {
        let evoHierarchy=(this.props.data.caseDetail.acquirerName=='EMD'||this.props.data.caseDetail.acquirerName=='EMI');

          return (this.props.data.merchantDetail_corporate)
           ?
                     <span>
            {`${this.props.data.merchantDetail_corporate}-${this.props.data.merchantDetail_region}-${this.props.data.merchantDetail_principal}-${this.props.data.merchantDetail_associate}-${this.props.data.merchantDetail_chain}`}
          </span>
          :
          evoHierarchy?
          <span>
           {`${this.props.data.merchantDetail.group}-${this.props.data.merchantDetail.chain}-${this.props.data.merchantDetail.taxID}`}
          </span>
          :
          <span>
            {`${this.props.data.merchantDetail.corporate}-${this.props.data.merchantDetail.region}-${this.props.data.merchantDetail.principal}-${this.props.data.merchantDetail.associate}-${this.props.data.merchantDetail.chain}`}
          </span>
        
      }
      if (item.displayType === 'INDICATOR') {
        return <span>{this.props.data && get(this.props.data, item.columnKey) === '1' ? '1' : (get(this.props.data, item.columnKey) === '9') ? ' ' : '0'}</span>;
      }
      if (item.displayType === 'LONGSTRING') {
        return <span>{get(this.props.data, item.columnKey)}</span>;
      }
      if (item.displayType === 'FILENAME') {
        return <span>{get(this.props.data, item.columnKey)}</span>;
      }
      if(item.displayType === 'INCOMING_MMT'){
        return(
          <div className='incoming_desc_container'>
            <div className='incoming_desc_container__value'>{this.props.data && get(this.props.data, item.columnKey)}</div>
          </div>
        );
      }
      if (item.displayType === "reason_code_with_description") {
        return (
          <div className='reason-code-container'>
            <div className='reason-code-container__code'>
              <div className='reason-code-container__code--value'>
                {!isEmpty(get(this.props.data, item.columnKey))
                  ? get(this.props.data, item.columnKey)
                  : "--"}
              </div>
              <div className='reason-code-container__code--infoBubble'>
                {<InformationBubble
                  id={`${item.columnKey.index}`}
                  info
                  tooltipContent={get(this.props.data, item.columnKeyDescription)}
                />}
              </div>
            </div>
            <div className='reason-code-container__description'>
              {!isEmpty(get(this.props.data, item.columnKeyDescription))
                ? get(this.props.data, item.columnKeyDescription)
                : "--"}
            </div>
          </div>
        );
      }
      if (item.displayType === 'MAILINGADDRESS') {
        return (<span >
          {get(this.props.data, item.columnKey)}</span>);
      } else {
        return <span >{get(this.props.data, item.columnKey)}</span>;
      } 
    } else if (typeof item.columnKey === 'object') {
      if (item.displayType === 'CARDTYPE_ACCOUNTNUMBER' && !isEmpty(get(this.props.data, item.columnKey.value2))) {
        return (
          <div>
            <CardType
              abbreviation={get(this.props.data, item.columnKey.value1)}
              type={get(this.props.data, item.columnKey.value1)}
            />
            <div className="overviewpane-account-cell">

              <GDAccountNumberCell
                accountNumber={get(this.props.data, item.columnKey.value2)}
                token={get(this.props.data, item.columnKey.value3)}
                isReadOnly={this.props.isReadOnly}
                isMerchantPortal={this.props.isMerchantUser}
              />

            </div>
          </div>
        );
      } else if (item.displayType === 'DATE_AMOUNT' && get(this.props.data, item.columnKey.value1) != null) {
        return (
          <div>
            <span className="date-cell">
              <GDDateCell
                key={`${item.columnKey.value1}`}
                date={get(this.props.data, item.columnKey.value1)}
                dateFormat={this.props.preferences.dateFormat}
                timeFormat={this.props.preferences.timeFormat}
              />
            </span>
            <span className="currency-cell">{this.getCurrencyCell(get(this.props.data, item.columnKey.value2), get(this.props.data, item.columnKey.value3), item.columnKey.value2, item.columnKey.value3)}</span>
          </div>
        );
      } else if (item.displayType === 'STRING_STRING') {
        return (
          <div>
            <span style={{ paddingRight: '30px' }}>{get(this.props.data, item.columnKey.value1)}</span>
            <span style={{ paddingLeft: '30px' }}>{!isEmpty(get(this.props.data, item.columnKey.value2)) ? get(this.props.data, item.columnKey.value2) : '--'}</span>
          </div>
        );
      } else if (item.displayType === 'CASE_STAGE_STAGE_ID') {
        return (
          <div className='txn-container-right'>
            <span className='txn-container-right__keyElem--stage_id'>{item.nameKeyObj.value2}</span>
            <span className='txn-container-right__valueElem--stage_id_value'>{this.props.caseHistory ? this.getLatestStageId(this.props.caseHistory) : '--'}</span>
          </div>
        );
      } else if (item.displayType === 'CARD_ORIGIN_AUTH_CODE') {
        return (
          <div className='txn-container-right'>
            <span className={item.nameKeyObj.value2 !== 'Auth Code' ? 'txn-container-right__keyElem' : 'txn-container-right__keyElem--auth_code'}>{item.nameKeyObj.value2}</span>
            <span className={item.nameKeyObj.value2 !== 'Auth Code' ? 'txn-container-right__valueElem' : 'txn-container-right__valueElem--auth_code_value'}>{!isEmpty(get(this.props.data, item.columnKey.value2)) ? get(this.props.data, item.columnKey.value2) : '--'}</span>
          </div>
        );
      } else if (item.displayType === 'POS_Code_Transaction_Code') {
        return (
          <div className='txn-container-right'>
            <span className='txn-container-right__keyElem'>{item.nameKeyObj.value2}</span>
            <span className='txn-container-right__valueElem'>{!isEmpty(get(this.props.data, item.columnKey.value2)) ? get(this.props.data, item.columnKey.value2) : '--'}</span>
            <span className='txn-container-right__tooltip'>
            {
            <InformationBubble
              id={`${item.columnKey.index}`}
              info
              tooltipContent={!isEmpty(get(this.props.data, item.columnKey.description)) ? get(this.props.data, item.columnKey.description) : "No Description Present"}
            />}
            </span>
          </div>
        );
      } else if (item.displayType === 'Ucaf_Tec') {
        return (
          <div className='txn-container-right'>
            <span className='txn-container-right__keyElem'>{item.nameKeyObj.value2}</span>
            <span className='txn-container-right__valueElem'>{!isEmpty(get(this.props.data, item.columnKey.value3))? get(this.props.data, item.columnKey.value3) : '-'}/{!isEmpty(get(this.props.data, item.columnKey.value2)) ? get(this.props.data, item.columnKey.value2) : '-'}</span>
            <span className='txn-container-right__tooltip'>
            {
            <InformationBubble
              id={`${item.columnKey.index}`}
              info
              tooltipContent={!isEmpty(get(this.props.data, item.columnKey.description)) ? get(this.props.data, item.columnKey.description) : "No Description Present"}
            />}
            </span>
          </div>
        );
      } else if (item.displayType === 'Avs_Chid') {
        return (
          <div className='txn-container-right'>
            <span className='txn-container-right__keyElem'>{item.nameKeyObj.value2}</span>
            <span className='txn-container-right__valueElem'>{!isEmpty(get(this.props.data, item.columnKey.value2)) || !isEmpty(get(this.props.data, item.columnKey.description)) ? get(this.props.data, item.columnKey.value2) : '--'}</span>
            <span className='txn-container-right__tooltip'>
            {
            <InformationBubble
              id={`${item.columnKey.index}`}
              info
              tooltipContent={!isEmpty(get(this.props.data, item.columnKey.description)) ? get(this.props.data, item.columnKey.description) : "No Description Present"}
            />}
            </span>
          </div>
        );
      } else if (item.displayType === 'STRING-STRING') {
        return (
          <div>
            <span>{isEmpty(get(this.props.data, item.columnKey.value1)) ? get(this.props.data, item.columnKey.value1) : '--'} - {!isEmpty(get(this.props.data, item.columnKey.value2)) ? get(this.props.data, item.columnKey.value2) : '--'}</span>
          </div>
        );
      } else if (item.displayType === 'DISPOSITION_CODE_DESC') {
        return (
          <div className='disposition-container'>
            <div style={{color:`${COLORS.oneGp.black}`}} className='disposition-container__code'>{!isEmpty(get(this.props.data, item.dispositionActivityCode)) && get(this.props.data, item.dispositionActivityCode)} - {!isEmpty(get(this.props.data, item.dispositionActionCode)) && get(this.props.data, item.dispositionActionCode)}</div>
            <div className='disposition-container__desc'>{!isEmpty(get(this.props.data, item.columnKey.value1)) && get(this.props.data, item.columnKey.value1)} - {!isEmpty(get(this.props.data, item.columnKey.value2)) && get(this.props.data, item.columnKey.value2)}</div>
          </div>
        );
      } else if (item.displayType === 'STRING/STRING') {
        return (
          <div>
            <span>{!isEmpty(get(this.props.data, item.columnKey.value1)) ? get(this.props.data, item.columnKey.value1) : '--'} / {!isEmpty(get(this.props.data, item.columnKey.value2)) ? get(this.props.data, item.columnKey.value2) : '--'}</span>
          </div>
        );
      } else if (item.displayType === 'ADDRESS') {
        return (
          <div>
            <span>{get(this.props.data, item.columnKey.value1)}</span><br />
            <span>{get(this.props.data, item.columnKey.value2)}</span>
          </div>
        );
      } else if (item.displayType === 'DATEAMONUTARRAY') {
        if (Array.isArray(get(this.props.data, item.jsonColumnKey))) {
          if (get(this.props.data, item.jsonColumnKey).length <= 0) {
            return <span>--</span>;
          }
          return this.displayDateAmountArray(get(this.props.data, item.jsonColumnKey), item);
        } else if (get(this.props.data, item.jsonColumnKey) != null) {
          return (
            <div>
              <span className="date-cell">
                <GDDateCell
                  key={`${item.columnKey.value1}`}
                  date={get(this.props.data, `[${item.jsonColumnKey}][${item.columnKey.value1}]`)}
                  dateFormat={this.props.preferences.dateFormat}
                  timeFormat={this.props.preferences.timeFormat}
                />
              </span>
              <span className="currency-cell">{this.getCurrencyCell(get(this.props.data, `[${item.jsonColumnKey}][${item.columnKey.value2}]`), get(this.props.data, `[${item.jsonColumnKey}][${item.columnKey.value3}]`), item.columnKey.value2, item.columnKey.value3, item.displayType)}</span>
            </div>
          );

        }
      }
      if (item.displayType === 'CURRENCY_UNIT') {
        return (
          <span className="currency-cell">{this.getCurrencyCell(get(this.props.data, item.columnKey.value1), get(this.props.data, item.columnKey.value2), item.columnKey.value1, item.columnKey.value2, item.displayType)}</span>
        );
      }
    }
    return <span>--</span>;
  };


  displayDateAmountArray = (array, item) => {
    return array.map((element) => {
      return (
        <div>
          {(element[item.columnKey.value1] !== null) && <span className="date-cell">
            <GDDateCell
              key={`${item.columnKey.value1}`}
              date={get(element, item.columnKey.value1)}
              dateFormat={{}.dateFormat}
              timeFormat={{}.timeFormat}
            />
          </span>}

          <span className="currency-cell">{this.getCurrencyCell(get(element, item.columnKey.value2), get(element, item.columnKey.value3), item.columnKey.value2, item.columnKey.value3, item.displayType)}</span>
        </div>
      );
    })
  }


  getCurrencyCell = (amount, currency, columnKey1, columnKey2, displayType, isNormalizedValue) => {
    if (currency !== undefined) {
      const normalizedValue = isNormalizedValue ? amount : amount == 0 ? 0 : (Math.round(amount * 100) / 100).toFixed(2) || '--';
      const normalizedUnits = currency || '';
      let valueClass;
      if (Number.isNaN(Number.parseFloat(amount))) {
        return <span key={`${columnKey1}`}>{normalizedValue}</span>;
      }

      if (!Number.isNaN(Number.parseFloat(normalizedValue)) && Number.parseFloat(normalizedValue) < 0) { valueClass = customFormatclass(customClassCurrency, displayType); }
      return (
        <GDCurrencyCodeCell
          key={`${columnKey1}`}
          value={normalizedValue}
          units={normalizedUnits}
          customClass={valueClass}
        />
      );
    } else {
      let valueClass;
      const normalizedValue = amount !== '' ? amount : '--';
      if (!Number.isNaN(Number.parseFloat(normalizedValue)) && Number.parseFloat(normalizedValue) < 0) { valueClass = customFormatclass(customClassCurrency, item.displayType); }
      return (
        <GDCurrencyCodeCell
          key={`${columnKey1}`}
          value={normalizedValue}
          customClass={valueClass}
        />
      );
    }
  };

  getLatestStageId = (data) => {
    return data.map(i => i.caseStageId).sort((a, b) => b - a)[0];
  }

  displayIcon = (id) => {
    switch (id) {
      case 1:
        return DisputeIcon;
      case 2:
        return TransactionIcon;
      case 3:
        return MerchantIcon;
      case 4:
        return SchemeIcon;
      case 5:
        return BankIcon;
      case 6:
        return AccountIcon;
      default:
        return DisputeIcon;
    }
  };

  getAccountingData = (item) => {
    if (this.props.accountingData !== null && item.displayType === "account-ledgers") {
      return <div>{this.getAccountLedgersCard(this.props.accountingData)}</div>;
    }
    if (item.displayType === 'DATE') {
      return (
        <span className="date">
          {
            this.props.accountingData && this.props.accountingData.length !== 0 ? (
              <GDDateCell
                key={`${item.columnKey}`}
                date={get(this.props.accountingData[0], item.columnKey)}
                dateFormat={this.props.preferences.dateFormat}
                timeFormat={this.props.preferences.timeFormat}
              />
            ) : (
              <span>--</span>
            )}
        </span>
      );
    } else if (item.displayType === 'STRING') {
      return <span>{this.getStringDisplayTypeValue(item)}</span>;
    }
  return <span>--</span>;
  };

  getStringDisplayTypeValue = (item) => {
    if (item.columnKey === 'delayDebit') {
      if (this.props.data?.caseStageDetail?.merchantNumber === null || this.props.data?.caseStageDetail_merchantNumber === null)
        return '--'
      return this.props.data?.caseDetail_delayDebitFlag ? this.props.data.caseDetail_delayDebitFlag : this.props.data?.caseDetail?.delayDebitFlag;
    }
    else if (this.props.accountingData && this.props.accountingData.length !== 0) {
      return get(this.props.accountingData[0], item.columnKey)
    }
    return '--'
  }

  getCSSStyle = (item) => {
    if (item.description == 'MccDescription') {
      return 'overviewpane-list-item-content-MCCDescription';
    } else if ((item.displayType === 'LONGSTRING' || item.displayType === 'STRING-STRING' || item.displayType === 'FILENAME') && !isEmpty(get(this.props.data, item.columnKey)) && get(this.props.data, item.columnKey) !== null && get(this.props.data, item.columnKey).length > 25) {
      return 'long-string';
    }
    return ;
  }

  getAccountLedgersCard = (data) => {
    let counterPending = 0;
    let counterComplete = 0;
    let obj = {
      stageId: "",
      complete: [],
      pending: [],
    };

    data.forEach((ledger) => {
      obj = {
        ...obj,
        stageId: ledger,
        complete: data.filter((item) => item.status === "COMPLETE"),
        pending: data.filter((item) => item.status === "PENDING"),
      };
    });
    return <div>
      <div className='stageTableAccount__ledgers'>Ledger Entries</div>
      <div>
            {obj["complete"].map((item) =>{
              if(counterComplete === 0){
                counterComplete = counterComplete +1;
                return (
                  <div >   
                  <div className='stageTableAccount stageTableAccount__header-space'>       
                      <div className="stageTableAccount__col"><StatusChip status= {item.status} /></div>
                      <div className="stageTableAccount__col stageTableAccount__date">{dateFormatter(item.adjustmentDate)}</div>
                      <div className="stageTableAccount__col stageTableAccount__user">{item.user}</div>
                    </div>
                    <div className='stageTableAccount stageTableAccount__mergin-dis'>         
                      <div className="stageTableAccount__col"><span  className="stageTableAccount__amount">{item.accountNumber}</span>{item.adjustment === 'CREDIT' ? <span className="stageTableAccount__cr-dr"> CR</span>:<span className="stageTableAccount__cr-dr"> DR</span>}</div>
                      <div className="stageTableAccount__col stageTableAccount__desc">{item.accountDescription.includes('Ledger')?item.accountDescription.replace('Ledger',''):item.accountDescription}</div>
                      <div className="stageTableAccount__col stageTableAccount__user">{<span className='stageTableAccount__adjustment'>{item.amount} <span className="stageTableAccount__curencyCode">{item.numericCurrencyCode}</span> </span>}</div>
                  </div>
                  </div>  
                    ) 
              }
            return (
                  <div className='stageTableAccount'>         
                      <div className="stageTableAccount__col"><span  className="stageTableAccount__amount">{item.accountNumber}</span>{item.adjustment === 'CREDIT' ? <span className="stageTableAccount__cr-dr"> CR</span>:<span className="stageTableAccount__cr-dr"> DR</span>}</div>
                      <div className="stageTableAccount__col stageTableAccount__desc">{item.accountDescription.includes('Ledger')?item.accountDescription.replace('Ledger',''):item.accountDescription}</div>
                      <div className="stageTableAccount__col stageTableAccount__user">{<span className='stageTableAccount__adjustment'>{item.amount} <span className="stageTableAccount__curencyCode">{item.numericCurrencyCode}</span> </span>}</div>
                  </div>
                  ) 
          
          })}
          </div>
          <div>
            {obj["pending"].map((item) =>{
              if(counterPending === 0){
                counterPending = counterPending +1;
                return (
                  <div >  
                  <div className='stageTableAccount stageTableAccount__header-space'>       
                      <div className="stageTableAccount__col"><StatusChip status= {item.status} /></div>
                      <div className="stageTableAccount__col stageTableAccount__date">{dateFormatter(item.adjustmentDate)}</div>
                      <div className="stageTableAccount__col stageTableAccount__user">{item.user}</div>
                    </div>
                    <div className='stageTableAccount stageTableAccount__mergin-dis'>         
                      <div className="stageTableAccount__col"><span  className="stageTableAccount__amount">{item.accountNumber}</span>{item.adjustment === 'CREDIT' ? <span className="stageTableAccount__cr-dr"> CR</span>:<span className="stageTableAccount__cr-dr"> DR</span>}</div>
                      <div className="stageTableAccount__col stageTableAccount__desc">{item.accountDescription.includes('Ledger')?item.accountDescription.replace('Ledger',''):item.accountDescription}</div>
                      <div className="stageTableAccount__col stageTableAccount__user">{<span className='stageTableAccount__adjustment'>{item.amount} <span className="stageTableAccount__curencyCode">{item.numericCurrencyCode}</span> </span>}</div>
                  </div>
                  </div>  
                    ) 
              }
            return (
                  <div className='stageTableAccount'>         
                      <div className="stageTableAccount__col"><span  className="stageTableAccount__amount">{item.accountNumber}</span>{item.adjustment === 'CREDIT' ? <span className="stageTableAccount__cr-dr"> CR</span>:<span className="stageTableAccount__cr-dr"> DR</span>}</div>
                      <div className="stageTableAccount__col stageTableAccount__desc">{item.accountDescription.includes('Ledger')?item.accountDescription.replace('Ledger',''):item.accountDescription}</div>
                      <div className="stageTableAccount__col stageTableAccount__user"> {<span className='stageTableAccount__adjustment'>{item.amount} <span className="stageTableAccount__curencyCode">{item.numericCurrencyCode}</span> </span>}</div>
                  </div>
                  ) 
          
          })}
          </div>
    </div>
    
  };

  render() {
    // const redirectUri = `https://${window.location.hostname}`;
    // let acquirerName = JSON.parse(sessionStorage.getItem("state")).auth.user.acquirerName;
    // const isCitiUser =  redirectUri.includes(VITE_CITI_BRANDED_URL) || acquirerName.includes('Citi');
    let dataColumn1 = this.props.isCitiUser ? this.props.dataColumns.filter(item => item.name !== 'Authorized' && item.name !== 'Authorization') : this.props.dataColumns;
    return (
      <div className="overviewpane" id={this.props.id}>
        <div className="overviewpane-title">
          <Row>
            <Col span={22}><h2 className="titleContent">{this.props.element.title}</h2></Col>
            {!this.props.isMerchantUser && this.props.element.isExpandable && <Col span={2}>
              <div className="expand-icon">
                <OpenNewWindowIcon
                  onClick={() => this.props.gotoExtraCaseDetailsPage(this.props.element.id)}
                />
              </div>
            </Col>
            }
            {this.props.isInvestigatorPortal && this.props.element.title == "Dispute Overview" && <Col span={2}>
              <div>
                <SearchIcon
                  action={this.props.getRelatedCaseSearchData}
                  isAction={true}
                />
              </div>
            </Col>
            }
            {this.props.isInvestigatorPortal && this.props.element.title == "Transaction Overview" && <Col span={2}>
              <div>
                <SearchIcon
                  action={this.props.getRelatedTransactionSearchData}
                  isAction={true}
                />
              </div>
            </Col>
            }
          </Row>
        </div>

          <ul className="overviewpane-list">
            {
              dataColumn1.map((item, index) => {
                
                return (<li className={this.props.element.title == 'Merchant Overview' ? 'overviewpane-list-item-merchant ' : item.displayType === 'account-ledgers'? '':
                 'overviewpane-list-item ' + item.displayType} key={index}>
                  <div className={item.displayType  === 'account-ledgers' ? '': (item.displayType === 'reason_code_with_description' ? "overviewpane-list-item-wrapper--reason-code-desc" : (item.displayType !== "DISPOSITION_CODE_DESC" ? (item.displayType !== "INCOMING_MMT" ? "overviewpane-list-item-wrapper" : "overviewpane-list-item-wrapper--incoming-mmt-desc") : "overviewpane-list-item-wrapper--disposition"))}>
                    <span className={item.displayType  === 'account-ledgers' ? '': (item.displayType !== "DISPOSITION_CODE_DESC" ? (item.displayType !== "INCOMING_MMT" ? "overviewpane-list-item-label" : "overviewpane-list-item-label--incoming-mmt-label") : "overviewpane-list-item-label--disposition")}>
                    {!item.KeyValueArr ? item.name : this.setTxnLeftRowValue(item.KeyValueArr)}
                      {item.showDescription && <InformationBubble
                        id={item.name}
                        info
                        tooltipContent={item.description}
                      />
                      }
                    </span>
                    <span style={{color:`${COLORS.oneGp.black}`}} className={this.getCSSStyle(item)}>
                      {this.props.element.id === 6 ? this.getAccountingData(item) : this.getItemData(item)}
                      </span>
                  </div>
                </li>);
              })
            }
          </ul>
        </div>
    );
  }
};

OverviewPane.propTypes = {
  element: PropTypes.object.isRequired,
  data: PropTypes.object,
  dataColumns: PropTypes.array.isRequired,
  gotoExtraCaseDetailsPage: PropTypes.func,
  accountingData: PropTypes.array,
  id: PropTypes.number,
  findHeight: PropTypes.func,
  divHeight: PropTypes.number,
  divHeightArray: PropTypes.array,
  isReadOnly: PropTypes.bool,
  isMerchantUser: PropTypes.bool,
  preferences: PropTypes.object,
  getRelatedCaseSearchData: PropTypes.func,
  getRelatedTransactionSearchData: PropTypes.func,
  isInvestigatorPortal: PropTypes.bool,
};

OverviewPane.defaultProps = {
  data: {},
  accountingData: [],
  gotoExtraCaseDetailsPage: () => { },
  divHeight: 440,
  divHeightArray: [],
  findHeight: () => { },
  isMerchantUser: false,
  preferences: {},
  getRelatedCaseSearchData: () => { },
  getRelatedTransactionSearchData: () => { },
  isInvestigatorPortal: false,
  caseHistory: []
};


export default OverviewPane;
